/**
 * Parses raw tool-call arguments from the model into a typed object.
 *
 * The model may return arguments as a JSON string or as an already-parsed
 * object, depending on the API layer. This helper normalises both cases.
 */
export function parseArgs<T>(rawArgs: object | string): T {
  if (typeof rawArgs === "string") {
    return JSON.parse(rawArgs) as T;
  }
  return (rawArgs ?? {}) as T;
}
